import type { AssigneeItem } from "../task-assignee-picker/task-assignee-picker.component";

type CurrentEmployee = { employee_id?: string; eva_company_id?: string; first_name?: string; last_name?: string };

/**
 * Assigné par défaut d'une nouvelle tâche : l'utilisateur courant, s'il est collaborateur de l'entreprise.
 * Un superadmin connecté sur une autre entreprise n'y est pas collaborateur : pas d'assigné par défaut (EP-1120).
 */
export function defaultAssigneeFor(employee: CurrentEmployee | null, evaCompanyId: string): AssigneeItem | null {
  if (!employee?.employee_id) return null;
  if (employee.eva_company_id && evaCompanyId && employee.eva_company_id !== evaCompanyId) return null;
  return {
    type: "employee",
    employee_id: employee.employee_id,
    name: `${employee.first_name || ""} ${employee.last_name || ""}`.trim(),
  };
}
